import { BordTextButton, TbordOneToneIcon } from 'bord-design-system';
import './QuoteEditorMetaDataItem.scss';

interface IQuoteEditorMetaDataItem {
  label: string;
  value: string;
  icon?: TbordOneToneIcon;
  flagUrl?: string;
  organizationId?: number;
}

/**
 * Elemento de metadata del encabezado del editor de cotización.
 * Muestra una etiqueta, un valor, opcionalmente un botón con icono para navegar
 * a los detalles de la organización, y opcionalmente una bandera de país.
 */
const QuoteEditorMetaDataItem = ({ label, value, icon, flagUrl, organizationId }: IQuoteEditorMetaDataItem) => {
  const goToOrganizationDetails = () => {
    if (!organizationId) return;
    window.open(`/organization/details/${organizationId}`, '_blank');
  };

  return (
    <span className="quoteEditorMetaDataItem">
      <span className="metaLabel">{label}</span>
      <span className="metaValue">{value}</span>
      {icon && organizationId && (
        <BordTextButton
          text=""
          onClick={goToOrganizationDetails}
          rightIconProps={{
            variant: icon,
            standardSize: 12,
            stroke: '#00B188'
          }}
        />
      )}
      {flagUrl && (
        <span className="countryFlag">
          <img alt={`Bandera de ${value}`} src={flagUrl} />
        </span>
      )}
    </span>
  );
};

export default QuoteEditorMetaDataItem;
